import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { api_url } from "../../../../../../constants";
import FormGenerator from "../../../../../../Components/FormGenerator";
import { SetBackground, UpdateBackgroundError } from "./BackgroundActions";
import { useParams, useLocation } from "react-router";
// const theme = createMuiTheme({
//   overrides: {
//     MuiFormControl: {
//       root: {
//         width: "100%",
//       },
//     },
//   },
// });

export default function Background(props) {
  const dispatch = useDispatch();

  // const userRole = sessionStorage.getItem("role");
  const globaluserData = useSelector((state) => state.commonReducer);
  const userRole = globaluserData?.role;


  const [feildIsMandatory, setFeildIsMandatory] = useState(true);
  useEffect(() => {
    if (userRole === "employee") {
      setFeildIsMandatory(false);
    }
  }, []);

  const { last_job_title, role_experience, disciplines } = useSelector(
    (state) => state.backgroundReducer.data
  );
  const reducerData = useSelector((state) => state.backgroundReducer.data);
  const disciplineSelector = useSelector(
    (state) => state.commonReducer.employeeDropdowns.disciplines
  );
  const { lawful_bia, contact_statuses } = useSelector(
    (state) => state.commonReducer.employeeDropdowns
  );

  const errors = useSelector((state) => state.backgroundReducer.errors);

  const handleInputChange = (value, index, type) => {
    props.setSomeChangeDetected(true);
    const updatedForm = formInput;
    if (!type) {
      updatedForm[index]["value"] = value;
    } else {
      updatedForm[index][type] = value;
    }
    setFormInput(updatedForm);
    const formData = {};
    formInput.forEach((item) => {
      if (item.value || item.inputValue || item.selectValue) {
        item.value && (formData[item.name] = item.value);
        item.inputValue && (formData[item.inputName] = item.inputValue);
        item.selectValue && (formData[item.selectName] = item.selectValue);
        dispatch(SetBackground(formData));
      }
    });
    dispatch(UpdateBackgroundError(updatedForm[index].name));
  };

  // Form disabling
  const location = useLocation();
  // let { organisation_id, employee_id } = JSON.parse(
  //   // sessionStorage.getItem("user")
  //   globaluserData?.userData
  // )?.data;
  let organisation_id = globaluserData?.organisation_id;
  let employee_id = globaluserData?.employee_id;
  const params = useParams();
  let unEditable = false;
  const isSameEmployee =
    userRole === "employee" &&
    Number(params.id) === Number(organisation_id) &&
    Number(employee_id) === Number(params.employeeid);
  if (location?.state?.unEditable && !isSameEmployee) {
    unEditable = true;
  }
  const formDisabler = (el) => {
    if (unEditable) {
      return { ...el, disabled: true };
    } else {
      return el;
    }
  };
  const formArray = [
    {
      componentType: "input",
      type: "text",
      label: "Last job title",
      // helperText: errors.consent_terms && "Please enter a Consent Terms",
      name: "last_job_title",
      placeholder: "Last job title",
      handleChange: handleInputChange,
      value: last_job_title,
    },
    {
      componentType: "input",
      type: "text",
      label: "What was your role experience?",
      multiline: true,
      // helperText: errors.consent_terms && "Please enter a Consent Terms",
      name: "role_experience",
      placeholder: "What was your role experience?",
      handleChange: handleInputChange,
      value: role_experience,
    },
    {
      componentType: "multiSelectChip",
      label: "Disciplines worked in",
      name: "disciplines",
      placeholder: "Select disciplines worked in",
      itemArr: disciplineSelector,
      selectOptions: disciplineSelector,
      // id: "disciplines",
      value: disciplines,
      handleChange: handleInputChange,
      dropDown: "Discipline",
      field_name: "discipline",
    },
  ];

  const [formInput, setFormInput] = useState(formArray);

  useEffect(() => {
    setFormInput(formArray);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors]);

  return (
    <FormGenerator
      children={formInput.map(formDisabler)}
      submitURL={api_url.organisation}
      handleNext={props.handleNext}
      nextIndex={2}
      setId={props.setId}
    />
  );
}
